exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs__tab-container--2Ymd_ {\n\theight: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"tab-container": "tabs__tab-container--2Ymd_"
};